/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FareType {
    Published = 'Published',
    Private = 'Private',
    ITX = 'ITX',
    TIM = 'TIM'
}

export function FareTypeFromJSON(json: any): FareType {
    return FareTypeFromJSONTyped(json, false);
}

export function FareTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareType {
    return json as FareType;
}

export function FareTypeToJSON(value?: FareType | null): any {
    return value as any;
}

